import _ from 'underscore';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { HotelGroup } from '@bingads-webui/hotel-odata-schemas';

import { HotelGridOptionsBase } from './hotel-grid-options-base';
import { gridOptionUtils } from '../hotel-center-service';

const jsdata = globalContext.require('campaignui/feature/hotel-center-js-data/index');
const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const state = globalContext.require('component/state/index');

export default class HotelGroupGridOptions extends HotelGridOptionsBase {
  constructor({
    view,
    gridName,
    dateFilterContainer,
    onBulkEditChangeBids,
    onBulkEditChangeMultipliersBids,
    onBulkEditIncreseOrDecreseBids,
    serverContext,
    preferenceService,
    p$daterange,
    filterService,
    viewport,
    customHeaderOffset,
  }) {
    const entitySet = gridOptionUtils.getEntitySetByName('hotelGroup');
    const searchBoxLabel = i18n.getString('HotelCenter_Overview_Grid_SearchBox_Hotel_Group_Label');

    super({
      view,
      gridName,
      dateFilterContainer,
      schema: HotelGroup,
      entitySet,
      searchBoxLabel,
      onBulkEditChangeBids,
      onBulkEditChangeMultipliersBids,
      onBulkEditIncreseOrDecreseBids,
      serverContext,
      preferenceService,
      p$daterange,
      filterService,
      viewport,
      customHeaderOffset,
    });

    this.i18n = i18n;

    let allColumns = [];
    this.plugins.columnChooser.categories[0].options.unshift({
      key: 'Id',
      name: this.i18n.getString('HotelCenter_Overview_Grid_Hotel_Group_ID_Label'),
      selectOption: 'optional',
    });
    this.plugins.columnChooser.categories[0].options.push({
      key: 'HotelAssociationCount',
      name: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Hotel_Association_Count_Label'),
      selectOption: 'optional',
    });
    allColumns = _.pluck(this.plugins.columnChooser.categories[0].options, 'key').concat(['Metrics', 'BidSource', 'BidMultiplierSource']);
    this.plugins.columnChooser.selected = ['Name', 'Id', 'HotelAssociationCount', 'Bid', 'BidMultipliers', 'Clicks', 'Impressions', 'CTR', 'Spend', 'AverageCPC', 'AveragePosition'];
    this.plugins.columnChooser.locked = ['Name'];

    if (!state.get('subAccount_id')) {
      this.plugins.columnChooser.selected.push('SubAccountName');
      this.plugins.columnChooser.categories[0].options.push({
        key: 'SubAccountName',
        name: this.i18n.getString('HotelCenter_Overview_Grid_Shared_SubAccount_Name_Label'),
        selectOption: 'optional',
      });
      allColumns = _.pluck(this.plugins.columnChooser.categories[0].options, 'key').concat(['Metrics', 'BidSource', 'BidMultiplierSource', 'SubAccountId']);
    }

    this.dataSource = _.defaults(this.dataSource, {
      resource: jsdata.HotelGroup,
      entity: jsdata.HotelGroup,
      query: {
        $select: allColumns.join(','),
      },
    });

    this.columns = this.columns.concat([bingadsGridColumn({
      name: 'HotelAssociationCount',
      title: this.i18n.getString('HotelCenter_Overview_Grid_SubAccount_Hotel_Association_Count_Label'),
      type: 'number',
      format: 'integer',
    }), bingadsGridColumn({
      name: 'Id',
      title: this.i18n.getString('HotelCenter_Overview_Grid_Hotel_Group_ID_Label'),
    })]);

    this.plugins.placeholder = {
      // Message for no results when using filter
      filteredContainer: '.grid-noresult',
      filteredEmptyText: i18n.getString('HotelCenter_Grid_NoFilteredRecords'),

      // Message for no data at all.
      container: '.grid-noresult',
      text: i18n.getString('HotelCenter_Overview_HotelGroup_Grid_NoRecords'),
    };
  }
}
